module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageContentPage":null}}')
  delete Component.options._Ctor
}
